<template>
  <!--
  <PageWelcome />
  -->
  <router-view />
</template>

<script setup lang="ts">
  import PageHome from './components/PageHome.vue'
</script>
